<template>
	<div>

		<vx-card :title="'Hours By Category (' + selectedQuarter.Title + ')'" class="mt-8">
			<template slot="actions">
				<v-select :options="allQuarterlyData" label="Title" v-model="selectedQuarter" placeholder="Category" style="width:150px;"/>
			</template>

			<vue-apex-charts type="bar" height="350" :options="BarChartOptions()" :series="QuarterSeries()"></vue-apex-charts>
		</vx-card>
		<vx-card title="Line Area Chart" class="mt-8">
			<vue-apex-charts type="line" height="350" :options="LineChartOptions()" :series="LineChartSeries()"></vue-apex-charts>
		</vx-card>


		<vx-card title="Monthly Times" class="mt-8">
			<!-- TASKS -->

			<vs-table stripe max-items="50" no-data-text="No Time Entries" pagination :data="monthlyTable">
				<template slot="header">
					
				</template>
				<template slot="thead">
					<vs-th> Hours Worked by Category </vs-th>

					<vs-th v-for="(month, index) in LineChartMonths()" :key="index"> {{month}} </vs-th>
					
					<vs-th> Total </vs-th>
				</template>
				

				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

						<vs-td> 
							<vx-tooltip :text="tr.CategoryName" color="primary">
							<div class="monthlyTimesCategory">{{tr.CategoryName}} </div> 
							</vx-tooltip>

							</vs-td>

						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[0])}"> {{tr.MonthHours[0]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[1])}"> {{tr.MonthHours[1]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[2])}"> {{tr.MonthHours[2]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[3])}"> {{tr.MonthHours[3]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[4])}"> {{tr.MonthHours[4]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[5])}"> {{tr.MonthHours[5]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[6])}"> {{tr.MonthHours[6]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[7])}"> {{tr.MonthHours[7]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[8])}"> {{tr.MonthHours[8]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[9])}"> {{tr.MonthHours[9]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[10])}"> {{tr.MonthHours[10]}} hrs</vs-td>
						<vs-td v-bind:style="{color: ElColor(tr.MonthHours[11])}"> {{tr.MonthHours[11]}} hrs</vs-td>

						<vs-td> {{Math.round(tr.CategoryTotal)}} </vs-td>
					

					</vs-tr>
					
				</template>
			</vs-table>
			</vx-card>


	</div>
</template>


<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
const moment = require('moment') // require
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'


export default{
  components:{
    flatPickr,
    'v-select': vSelect,
    VueApexCharts
  },
  data () {
    return {
      selectedQuarter	: {'WorkQuarter':2, 'WorkYear':2020, 'ID':0, 'Title':'Nothing'},
      months			: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },
  watch:{
    allQuarterlyData (x) {
      if (x != null) {
        if (x.length > 0) {
          this.selectedQuarter = x[0]
        }
      }
    }
  },
  computed:{
    monthlyTable () {
      return this.$store.getters.GetMonthlyTable
    },
    allQuarterlyData () {
      return this.$store.getters.GetQuarterlyData
    }
  },
  methods: {
    LineChartOptions () {
      return {
        'dataLabels': {
          'enabled': false
        },
        'stroke': {
          'curve': 'smooth'
        },
        'colors': ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#4206ae', '#724e50', '#76b3fd', '#15f967', '#44fab3', '#81b3c7', '#a07c4b', '#06814c', '#a82891', '#cec7d7', '#d29251', '#ab5469', '#f7b421', '#2e769c', '#9057e6', '#9c7686', '#ea488c', '#2e929f', '#cfa289', '#32735f', '#84396b', '#04c7d2', '#4cd547', '#c80736', '#f999b9', '#38fb1', '#44c35f'],
        'xaxis': {
          'type': 'text',
          'categories': this.LineChartMonths()
        },
        'tooltip': {
          'x': {
            'format': 'dd/MM/yy HH:mm'
          }
        }
      }
    },
    LineChartMonths () {
      const currentYear = (parseInt(moment().format('YY')))
      const currentMonth = (parseInt(moment().format('M')) - 3)
      const shiftedMonths = []
      for (let i = 0; i < 12; i++) {
        let newI = i - currentMonth
        let year = ` '${  currentYear}`
        if (newI < 0) {
          newI += 12
          year = ` '${  currentYear - 1}`
        }
        shiftedMonths.push(this.months[newI] + year)
      }
      return shiftedMonths
    },
    LineChartSeries () {
      const series = []
      for (let i = 0; i < this.monthlyTable.length; i++) {
        const entry = this.monthlyTable[i]
        series.push({'name': entry.CategoryName, 'data': entry.MonthHours})
      }
      return series
    },
    QuarterData () {
      const data = this.allQuarterlyData.find(x => x.WorkQuarter == this.selectedQuarter.WorkQuarter && x.WorkYear == this.selectedQuarter.WorkYear)
      if (data != null) {
        return data
      }
      return {'Categories':[], 'Hours':[]}
    },
    QuarterSeries () {
      return [
        {
          data: this.QuarterData().Hours
        }
      ]
    },
    BarChartOptions () {
      return {
        'plotOptions': {
          bar: {
            horizontal: true
          }
        },
        'chart':{
          'height': 500
        },
        'dataLabels': {
          enabled: false
        },
        'xaxis': {
          categories: this.QuarterData().Categories
        }
      }
    },
    LerpColor (a, b, amount) { 
      let ah = parseInt(a.replace(/#/g, ''), 16), ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff, bh = parseInt(b.replace(/#/g, ''), 16), br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff, rr = ar + amount * (br - ar), rg = ag + amount * (bg - ag), rb = ab + amount * (bb - ab)
      return `#${  ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1)}`
    },
    ElColor (x) {
      if (x == 0) return '#575b6f'
      x /= 150
      if (x > 1) x = 1
      return this.LerpColor('#9097bb', '#7366f0', x)
      if (x == 0) return .2
      return 1
    }
		
  },
  mounted () {
    if (this.allQuarterlyData != null) {
      if (this.allQuarterlyData.length > 0) {
        this.selectedQuarter = this.allQuarterlyData[0]
      }
    }
  }
}

</script>

